import { ArrowUpRight } from "lucide-react";

const chapters = [
  ["01", "Estrazione", "Scegliamo i banchi a Tivoli e Guidonia prima che diventino superficie. La materia si legge nella sua origine, non in catalogo."],
  ["02", "Selezione diretta", "Seguiamo la lastra, il verso e la falda. Ogni taglio nasce da un dialogo preciso tra progetto, formato e venatura."],
  ["03", "Superfici", "Levigato, spazzolato, stuccato o a poro aperto: la finitura non copre la pietra. Ne rivela il carattere."],
  ["04", "Consegna", "Dal blocco al cantiere, senza passaggi anonimi. Un referente unico coordina scelta, lavorazione e arrivo."],
];

export default function ManifestoChapters() {
  return (
    <section className="manifesto-section" id="manifesto" data-testid="manifesto-chapters-section">
      <div className="site-container">
        <div className="section-heading section-heading-dark reveal">
          <span className="eyebrow">02 / Il metodo SIL</span>
          <h2>La materia non si ordina.<br /><i>Si sceglie.</i></h2>
          <p>Quattro gesti, un solo criterio: lasciare che il travertino faccia il suo lavoro.</p>
        </div>
        <div className="manifesto-list">
          {chapters.map(([number, title, copy], index) => (
            <article className={`manifesto-row reveal reveal-delay-${index + 1}`} key={number}>
              <span className="manifesto-number">{number}</span>
              <div className="manifesto-content"><h3>{title}</h3><p>{copy}</p></div>
              <span className="manifesto-index">0{index + 1} — 04 <ArrowUpRight size={17} /></span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
